
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".6","clip-path":"url(#clip0_995_7635)"}},[_c('path',{attrs:{"d":"M14 8c0 1.31-.419 2.519-1.131 3.506a1.5 1.5 0 101.603 1.2A7.985 7.985 0 0016 8 8 8 0 004.338.888c.58.368 1 .971 1.125 1.675A6.002 6.002 0 0114 8zm-6 6a6.002 6.002 0 01-4.869-9.506 1.5 1.5 0 10-1.603-1.2A7.984 7.984 0 000 8a8 8 0 008 8 7.965 7.965 0 003.65-.878 2.5 2.5 0 01-1.113-1.681C9.766 13.8 8.907 14 8 14zm4.162-8.29a1.25 1.25 0 00-1.521-1.657A4.72 4.72 0 008 3.25 4.752 4.752 0 003.25 8 4.752 4.752 0 008 12.75a4.752 4.752 0 004.162-7.04zM9.75 5.262c.006.643.5 1.175 1.131 1.234A3.254 3.254 0 018 11.253a3.251 3.251 0 01-3.25-3.25 3.252 3.252 0 015-2.737v-.003zM10 8a2 2 0 10-4 0 2 2 0 004 0z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_995_7635"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    